import {
  IpponCard,
  IpponContainer,
  IpponGrid,
  IpponGridSlot,
  IpponHSpace,
  IpponText,
  IpponTitle,
  IpponVSpace,
} from '@ippon-ui/react';
import { LoadingSkeleton } from '@/generic/loader';
import { HistorySummaryLoadingComponent } from '@/diagnostic/primary/HistorySummaryLoadingComponent.tsx';

const DiagnosticHistoryDiagnosticLoadingComponent = () => (
  <IpponGridSlot col={[4, 'm-6']}>
    <HistorySummaryLoadingComponent />
  </IpponGridSlot>
);

export const DiagnosticHistoryLoadingComponent = () => (
  <LoadingSkeleton>
    <IpponContainer>
      <IpponCard size="large" shadow="l3">
        <IpponVSpace gap={10}>
          <hgroup>
            <IpponHSpace gap={8} align="middle" wrap>
              <IpponTitle tag="h2" level={5} placeholder={true} />
              <IpponText tag="p" variant="body" placeholder />
            </IpponHSpace>
          </hgroup>
          <IpponGrid container={[4, 'm-12']} gap={[16, 'm-12']}>
            <DiagnosticHistoryDiagnosticLoadingComponent />
            <DiagnosticHistoryDiagnosticLoadingComponent />
            <DiagnosticHistoryDiagnosticLoadingComponent />
            <DiagnosticHistoryDiagnosticLoadingComponent />
          </IpponGrid>
        </IpponVSpace>
      </IpponCard>
    </IpponContainer>
  </LoadingSkeleton>
);
